import 'zone.js'; // Must be first so zone patches are applied before Angular bootstraps
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppShellComponent } from './app/app-shell.component';
import { AppComponent } from './app/app.component';
import { CollegePortfolioComponent } from './app/college-portfolio/college-portfolio.component';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';

bootstrapApplication(AppShellComponent, {
  providers: [
    provideAnimations(),
    provideHttpClient(),
    provideRouter([
      { path: '', component: AppComponent },
      { path: 'college-portfolio', component: CollegePortfolioComponent }
    ])
  ]
}).catch(err => console.error(err));
